'use client';

var FOLLOW_COMPANY_API_END_POINT = 'api-gateway/v1.0/profile/follow';
var DEFAULT_SUCCESS_CODE = 200;

export { DEFAULT_SUCCESS_CODE, FOLLOW_COMPANY_API_END_POINT };
//# sourceMappingURL=const.js.map
